/**
 * Переключатель-ползунок. Единый компонент для всего фронта.
 * label — текст справа от свичера.
 */
import '../../styles/components/toggle-switch.css'

export default function Switch({
  checked,
  onChange,
  label,
  ariaLabel,
  disabled = false,
  className = '',
}) {
  return (
    <label className={`ui-switch toggle-switch ${className}`.trim()}>
      <input
        type="checkbox"
        checked={!!checked}
        onChange={(e) => onChange?.(e.target.checked)}
        disabled={disabled}
        aria-label={ariaLabel || label}
        className="toggle-switch-input"
      />
      <span className="toggle-switch-track" aria-hidden>
        <span className="toggle-switch-thumb" />
      </span>
      {label && <span className="toggle-switch-label">{label}</span>}
    </label>
  )
}
